import React from 'react';
import { type IconName, PATH_MAP } from './icon-paths-24x24';

type IconProps = {
  name: IconName;
  size?: number;
  fill?: React.CSSProperties['color'];
  viewBox?: string;
};

const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  fill,
  viewBox = '0 0 24 24',
}) => {
  const paths =
    typeof PATH_MAP[name] === 'string' ? [PATH_MAP[name]] : PATH_MAP[name];
  return (
    <svg width={size} height={size} viewBox={viewBox} fill="none">
      {paths.map((path, index) => (
        <path key={index} d={path} fill={fill} />
      ))}
    </svg>
  );
};

export default Icon;
